/**
 * Runtime config, written to /config.js at deploy time from the stack outputs.
 * Kept out of the bundle so a rebuild is not required to repoint an environment.
 */
export interface AppConfig {
  apiUrl: string;
  userPoolId: string;
  userPoolClientId: string;
  region: string;
  /** Cognito hosted UI domain, for the Google redirect flow. */
  authDomain: string;
  /** False until the Google identity provider is actually wired up. */
  googleEnabled: boolean;
}

declare global {
  interface Window {
    EDH_CONFIG?: AppConfig;
  }
}

const fallback: AppConfig = {
  apiUrl: import.meta.env.VITE_API_URL ?? '',
  userPoolId: import.meta.env.VITE_USER_POOL_ID ?? '',
  userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID ?? '',
  region: import.meta.env.VITE_REGION ?? 'us-east-1',
  authDomain: import.meta.env.VITE_AUTH_DOMAIN ?? '',
  googleEnabled: import.meta.env.VITE_GOOGLE_ENABLED === 'true',
};

export const config: AppConfig = window.EDH_CONFIG ?? fallback;

export const apiBase = config.apiUrl.replace(/\/+$/, '');
